import React from "react";
import './App.css';
import { ElfsightWidget } from 'react-elfsight-widget';
import Header from './components/Header/Header.jsx';
import Main from './components/main/main.jsx';
import Numbers from './components/Numbers/Numbers.jsx';
import SpeakersFrom from './components/Speakers from/Speakers from.jsx';
// import WhatIWillLearn from './components/WhatIWillLearn/WhatIWillLearn.jsx';
// import FourKeys from './components/FourKeys/FourKeys.jsx';
// import FAQ from './components/FAQ/FAQ.jsx';
import Audience from './components/Audience/Audience.jsx';
import Photos from './components/Photos/Photos.jsx';
import TagCloud from './components/TagCloud/TagCloud.jsx';
import Speakers from './components/Speakers/Speakers.jsx';
import Packages from './components/Packages/Packages.jsx';
import AskCompany from "./components/AskCompany/AskCompany";
import Enterprise from "./components/Enterprise/Enterprise";
// import Workshops from "./components/Workshops/Workshops";
import Become from "./components/Become/Become";
// import Sponsors from "./components/Sponsors/Sponsors";
import Partners from "./components/Partners/Partners";
import PC from "./components/PC/PC";
import Mission from "./components/Mission/Mission";
import Reviews from './components/Reviews/Reviews.jsx';
// import JoinCommunity from './components/JoinCommunity/JoinCommunity';
import Team from './components/Team/Team.jsx';
import Event_about from './components/Event_about/Event_about.jsx';
import Footer from './components/footer/Footer.jsx';
import Countdown from './components/CountDown/CountDown';
import Agenda from './components/Agenda/Agenda';
import Translation from './components/Translation/Translation';

const App = (props) => {
  return (
    <main>
      <Header />
      <Main />
      <Translation />
      <Numbers />
      <SpeakersFrom />
      {/* <WhatIWillLearn /> */}
      {/* <FourKeys /> */}
      {/* <FAQ /> */}
      <Audience />
      <Photos />
      <Event_about />
      <Speakers />
      <Packages />
      <Agenda />
      <TagCloud />
      <AskCompany />
      <Enterprise />
      <Become />
      {/* <Workshops /> */}
      {/* <Sponsors /> */}
      <Partners />
      <PC />
      <Reviews />
      {/* <JoinCommunity /> */}
      <Team />
      <Mission />
      <ElfsightWidget widgetID="08227ea2-af6b-4d92-aac1-a8b0938e25b9" />
      <Footer />
      <Countdown />
    </main> 
  );
}

export default App;